import { Navigate } from "react-router-dom";
const RequireAuth = ({ children }) => {
  let accessToken = localStorage.getItem("AlEzziAdminToken");
  if (!accessToken) {
    return <Navigate to="/" replace />;
  }
  return children;
};

export default RequireAuth;
